import { IAppCache } from '../../../common/types/iapp-cache';
import { IPreCacheConfig } from '../interfaces/ipre-cache-config';

declare function postMessage(message: any): void;

declare function importScripts(...urls: string[]): void;

export const preCacheHandler = (config: IPreCacheConfig) => {
    importScripts(`${config.protocol}//${config.host}/scripts/crypto-runner.js`);

    const openRequest = self.indexedDB.open('cache', 1);

    openRequest.onsuccess = () => {
        const db: IDBDatabase = openRequest.result;

        // tslint:disable-next-line: no-console
        db.onerror = (e) => console.error(e);

        const keyRequest = db
            .transaction('api-cache', 'readonly')
            .objectStore('api-cache')
            .getAllKeys();

        keyRequest.onsuccess = () => {
            const keys = keyRequest.result as string[];

        };
    };

    openRequest.onupgradeneeded = (event: any) => {
        const db = event.target.result;
        db.createObjectStore('api-cache', {keyPath: 'id'});
    };



        const makeRequest = (
        requestUrl: string,
        db: IDBDatabase,
        action?: (body: any, db: IDBDatabase, locationId: number) => void,
        locationId?: number,
    ) => {
        const req = new XMLHttpRequest();

        req.onreadystatechange = () => {
            if (req.readyState === 4 && req.response) {
                const body = JSON.parse(req.response);
                cacheRequest(db, requestUrl, body);

                if (action) {
                    action(body, db, locationId);
                }
            }
        };

        req.open('GET', requestUrl);
        req.setRequestHeader('Authorization', 'Bearer ' + config.accessToken);
        req.send();
    };

    const cacheRequest = (db: IDBDatabase, requestUrl: string, body) => {
        let data: object | string = {
            body,
            headers: null,
            lazyUpdate: null,
            ok: true,
            status: 200,
            statusText: 'OK',
            type: 4,
            requestUrl
        };

        if (config.encrypt) {
            // @ts-ignore
            data = CryptoJS.AES.encrypt(JSON.stringify(data), config.publicKey).toString();
        }

        const id = /(api.+)$/.exec(requestUrl)[0];

        const document: IAppCache = {
            id: config.encrypt ? btoa(id) : id,
            created: Date.now(),
            data
        };

        const transaction = db
            .transaction('api-cache', 'readwrite')
            .objectStore('api-cache')
            .put(document);

        transaction.onsuccess = () => {
            // tslint:disable-next-line: no-console
            console.log(`${requestUrl} success!`);
        };
    };
};
